import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  OrganizationPlannedSurveysCount = 'OrganizationPlannedSurveysCount',
}

export const useGetOrganizationPlannedSurveysCountQuery = () => {
  const { getOrganizationPlannedSurveysCount } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.OrganizationPlannedSurveysCount],
    queryFn: () => getOrganizationPlannedSurveysCount(),
    refetchInterval: 60000,
  });
};
